import capterra from '@public/images/signup/capterra.webp';
import GetApp from '@public/images/signup/GetApp.webp';
import softwareadvice from '@public/images/signup/softwareadvice.webp';

/** Pixel size for award badges (SVGs are ~92×106 or 114×106; scaled to height 107). */
const AWARD_H = 107;
const AWARD_W_92 = Math.round((92 * AWARD_H) / 106);
const AWARD_W_114 = Math.round((114 * AWARD_H) / 106);

export const reassuranceLogos = [
    {
        image: capterra,
        alt: 'Capterra'
    },
    {
        image: softwareadvice,
        alt: 'Software Advice'
    },
    {
        image: GetApp,
        alt: 'GetApp'
    }
];

export const reassuranceLogosAwards = [
    {
        image: '/images/signup/SocialMediaAnalytics_HighPerformer_Winter2026-EMEA.svg',
        alt: 'Social Media Analytics High Performer EMEA',
        width: AWARD_W_92,
        height: AWARD_H
    },
    {
        image: '/images/signup/SocialMediaListeningTools_HighestUserAdoption_Winter2026.svg',
        alt: 'Social Media Listening Tools Highest User Adoption',
        width: AWARD_W_92,
        height: AWARD_H
    },
    {
        image: '/images/signup/SocialMediaManagement_RegionalLeader_Winter2026-EMEA.svg',
        alt: 'Social Media Management Regional Leader EMEA',
        width: AWARD_W_92,
        height: AWARD_H
    },
    {
        image: '/images/signup/SocialMediaSuite_HighPerformer_Winter2026-EMEA.svg',
        alt: 'Social Media Suites High Performer EMEA',
        width: AWARD_W_92,
        height: AWARD_H
    },
    {
        image: '/images/signup/Capterra_BestEaseOfUse_2026.svg',
        alt: 'Capterra Best Ease of Use 2026',
        width: AWARD_W_114,
        height: AWARD_H
    }
];
